import { Navigate, createPath, useLocation, type To } from 'react-router-dom';

interface SafeNavigateProps {
  to: To;
  replace?: boolean;
}

export function SafeNavigate({ to, replace = true }: SafeNavigateProps) {
  const location = useLocation();
  const currentTarget = `${location.pathname}${location.search}${location.hash}`;
  const nextTarget = typeof to === 'string' ? to : createPath(to);

  if (currentTarget === nextTarget) {
    return null;
  }

  return <Navigate to={to} replace={replace} />;
}
